import { render } from "./SupplierDetailView.vue?vue&type=template&id=0e7ef9e1&scoped=true"
import script from "./SupplierDetailView.vue?vue&type=script&lang=js"
export * from "./SupplierDetailView.vue?vue&type=script&lang=js"

import "./SupplierDetailView.vue?vue&type=style&index=0&id=0e7ef9e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7ef9e1"]])

export default __exports__